import { useWorkflowTemplateWithCardDefinition } from '@shared/scenes/workflows/hooks';
import { API } from '@shared/types/api';

/**
 * @deprecated Use `useWorkflowTemplate` instead.
 */
export function useCardDefinition(workflowTemplateId?: string | null): {
  loading: boolean;
  cardDefinition: API.CardDefinitionFragment | undefined;
} {
  const { workflowTemplate, loading } = useWorkflowTemplateWithCardDefinition(workflowTemplateId);

  return {
    loading,
    cardDefinition: workflowTemplate?.cardDefinition,
  };
}
